module.exports = __webpack_public_path__ + "assets/certificate_pdf/MTA Mobility and Device Fundamentals_98-368_F189-59048298419.a20fd1ad.pdf";